import { render } from "./PaymentMessage.vue?vue&type=template&id=ad0e2be0&lang=pug"
import script from "./PaymentMessage.vue?vue&type=script&lang=js"
export * from "./PaymentMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__